import { defineStore } from 'pinia';
import { fetchOfficialProfilesHandler } from '~/handlers/fetch-official-profiles.handler';
import { fetchOfficialProfileHandler } from '~/handlers/fetch-official-profile.handler';

export const useOfficialProfilesStore = defineStore(
  'ap.officialProfiles',
  () => {
    /** Índice (`GET /api/official-profiles`), já ordenado por `position`. */
    const list = ref<OfficialProfileListItem[]>([]);
    const listLoaded = ref(false);
    const listLoading = ref(false);

    /** Detalhes por slug. O índice e a página compartilham a mesma store. */
    const detailBySlug = ref<Record<string, OfficialProfileDetail>>({});

    /**
     * Slugs que já deram 404 (inexistente ou inativo). Guardar isso evita
     * refazer a request a cada navegação de volta pro mesmo perfil morto.
     */
    const missingSlugs = ref<Set<string>>(new Set());
    const detailLoading = ref(false);

    async function fetchList() {
      if (listLoaded.value || listLoading.value) return;

      listLoading.value = true;

      const { profiles } = await fetchOfficialProfilesHandler();

      list.value = profiles;
      listLoaded.value = true;
      listLoading.value = false;
    }

    /** `null` = perfil inexistente ou inativo; a página redireciona pro índice. */
    async function fetchDetail(
      slug: string,
    ): Promise<OfficialProfileDetail | null> {
      if (detailBySlug.value[slug]) return detailBySlug.value[slug];
      if (missingSlugs.value.has(slug)) return null;

      detailLoading.value = true;

      const { profile } = await fetchOfficialProfileHandler({ slug });

      if (profile) {
        detailBySlug.value[slug] = profile;
      } else {
        missingSlugs.value.add(slug);
      }

      detailLoading.value = false;

      return profile;
    }

    function reset() {
      list.value = [];
      listLoaded.value = false;
      listLoading.value = false;
      detailBySlug.value = {};
      missingSlugs.value = new Set();
      detailLoading.value = false;
    }

    return {
      list,
      listLoaded,
      listLoading,
      detailBySlug,
      detailLoading,
      fetchList,
      fetchDetail,
      reset,
    };
  },
);
